const measurementsInputs = [
    'customTopWidth', 
    'customBottomWidth', 
    'customLeftHeight', 
    'customRightHeight'
];
const measurementsGroup = document.getElementById('group-measurements');

measurementsInputs.forEach(input => {
    const inputEl = document.getElementById(input);

    inputEl.addEventListener('focus', function() {
        measurementsGroup.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // Scroll to the top of the div
        });
    });
});

const setNameInput = document.getElementById('setName');
const setNameGroup = document.getElementById('group-setName');

setNameInput.addEventListener('focus', function() {
    setNameGroup.scrollIntoView({
        behavior: 'smooth',
        block: 'start' // Scroll to the top of the div
    });
});


const numberOfDoorsInputs = [
    'numberOfDoors', 
    'trackStyle-double', 
    'trackStyle-triple',
];
const numberOfDoorsGroup = document.getElementById('group-doors-and-track-style');


numberOfDoorsInputs.forEach(input => {
    const inputEl = document.getElementById(input);
    inputEl.addEventListener('focus', function() {

        numberOfDoorsGroup.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // Scroll to the top of the div
        });
    });
});


const doorTypesAndInserts = [
    'insertOptionsSideBar', 
    'vinylOptionsSideBar', 
    'colonialOptionsSelectSideBar',
];
const groupDoorsTypesContainer = document.getElementById('group-doors-types');


doorTypesAndInserts.forEach(input => {
    const inputEl = document.getElementById(input);

    inputEl.addEventListener('focus', function() {

        groupDoorsTypesContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // Scroll to the top of the div
        });
    });
});

$('#addFloorBatten_option').on('change', (e) => {
    const focusDiv = document.getElementById('group-doors-and-track-style');
    focusDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'start' // Scroll to the top of the div
    });
});

$('#apply_to_all_doors_sidebar').on('change', (e) => {
    const focusDiv = document.getElementById('group-doors-types');
    focusDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'start' // Scroll to the top of the div
    });
});


document.getElementById('hide_configuration').addEventListener('click', function(e) {
    e.preventDefault();

    // const hideConfiguration = document.querySelector('.hide-configuration');

    // if (hideConfiguration.style.display !== 'block') {
    //     return;
    // } 


    const containerDiv = document.querySelector('.scrollable-content');
    const startHere = document.getElementById('startHere');
    const setNameValue = setNameInput.value;

    startHere.style.right = '-270px';
    startHere.style.top = '45px';
    startHere.style.display = 'block';

    if (containerDiv.classList.contains('active')) {
        startHere.style.display = 'none';

        containerDiv.classList.remove('active');
        document.querySelector('.hide-configuration').classList.remove('active');

        console.log('setNameValue', setNameValue);
        if (setNameValue == '' || setNameValue == null) {
            
            startHere.style.right = '-360px';
            startHere.style.top = '-9px';
            startHere.style.display = 'block';
        } else {
            startHere.style.display = 'none';
        }
    } else {
        containerDiv.classList.add('active');
        document.querySelector('.hide-configuration').classList.add('active');

        
    }

});

const scrollableDiv = document.querySelector('.scrollable');

scrollableDiv.addEventListener('click', function(event) {

    

    const containerDiv = document.querySelector('.scrollable-content');

    if (!event.target.closest('.scrollable-content.active') && 
        !event.target.closest('.hide-configuration.active') && 
        !event.target.closest('#hide_configuration')) 
    {
        console.log('The .scrollable div was clicked, but not .scrollable-content.active or its children');

        if (containerDiv.classList.contains('active') && window.innerWidth < 769) {
            document.getElementById('hide_configuration').click();
        }
    }
});



